import React, { useEffect, useState } from 'react';
import { Card, CardContent, Collapse, IconButton, Grid, Stack, Alert, ExpandLessIcon, ExpandMoreIcon } from "../../styles/MaterialUI";
import { useSelector } from 'react-redux';

const ExpandableScreenAlertCard = () => {
    const { appInfo, storageInfo } = useSelector(state => state.editScreenData);
    const [expanded, setExpanded] = useState(false);
    const [alertCount, setAlertCount] = useState(0);

    useEffect(() => {
        const count = [appInfo, storageInfo].filter(info => Object.keys(info).length > 0).length;
        setAlertCount(count);
    }, [appInfo, storageInfo]);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        alertCount !== 0 &&
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card style={{
                overflow: "auto", color: "#003366", padding: "5px", backgroundColor: "#fff4e5",
                boxShadow: 'rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset'
            }}>
                <Stack direction="row" display="flex" justifyContent="space-between" alignItems="center">
                    <h4 style={{ color: "#003366", margin: "0 0 0 10px", width: "100%" }}>Alerts <span style={{ fontSize: "13px" }}>({alertCount})</span></h4>
                    <IconButton aria-label="ExpandCollapseCard" size='small' style={{ marginRight: "10px", color: "#003366" }} onClick={handleExpandClick}>
                        {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                </Stack>
                <Collapse in={expanded} timeout="auto" unmountOnExit sx={{ transition: "0.3s ease-in-out" }}>
                    <CardContent style={{ marginTop: "-15px", paddingBottom: "5px" }}>
                        <Stack sx={{ width: '100%' }}>
                            {appInfo && Object.keys(appInfo).length > 0 && <Alert severity="warning" sx={{ fontSize: "12px" }}>
                                The version <em><b>{appInfo.screen_apkversion}</b></em> of the AristoCAST app currently installed on this device is outdated. Please update the app on the device to the latest version <em><b>{appInfo.latest_apkversion}</b></em>.
                                <a href={appInfo.link} target="_blank" style={{ color: "#003366", textDecoration: "none" }}>{" "}Learn More</a>
                            </Alert>}
                            {storageInfo && Object.keys(storageInfo).length > 0 && <Alert severity="warning" sx={{ fontSize: "12px", marginTop: alertCount === 2 ? "-15px" : 0 }}>
                                The content currently mapped to this Screen requires <em><b>{storageInfo.totalFileSize}MB</b></em>, but the device may not have the required storage.
                                <a href={storageInfo.link} target="_blank" style={{ color: "#003366", textDecoration: "none" }}>{" "}Learn More</a>
                            </Alert>}
                        </Stack>
                    </CardContent>
                </Collapse>
            </Card>
        </Grid>
    );
};

export default ExpandableScreenAlertCard;
